function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { animated, useSpring } from "@react-spring/web";
import { useDrag } from "@use-gesture/react";
import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { Slide } from "./slide";
import { bound } from "../../utils/bound";
import { convertPx } from "../../utils/covert-px";
var classPrefix = "tc-image-viewer";
export var Slides = /*#__PURE__*/forwardRef(function (props, ref) {
  var slideWidth = window.innerWidth + convertPx(16);
  var _useSpring = useSpring(function () {
      return {
        x: props.defaultIndex * slideWidth,
        config: {
          tension: 250,
          clamp: true
        }
      };
    }),
    _useSpring2 = _slicedToArray(_useSpring, 2),
    x = _useSpring2[0].x,
    api = _useSpring2[1];
  var count = props.images.length;
  function swipeTo(index) {
    var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var _a;
    var i = bound(index, 0, count - 1);
    (_a = props.onIndexChange) === null || _a === void 0 ? void 0 : _a.call(props, i);
    api.start({
      x: i * slideWidth,
      immediate: immediate
    });
  }
  useImperativeHandle(ref, function () {
    return {
      swipeTo: swipeTo
    };
  });
  var dragLockRef = useRef(false);
  var bind = useDrag(function (state) {
    if (dragLockRef.current) return;
    var _state$offset = _slicedToArray(state.offset, 1),
      offsetX = _state$offset[0];
    if (state.last) {
      var minIndex = Math.floor(offsetX / slideWidth);
      var maxIndex = minIndex + 1;
      var velocityOffset = Math.min(state.velocity[0] * 2000, slideWidth) * state.direction[0];
      swipeTo(bound(Math.round((offsetX + velocityOffset) / slideWidth), minIndex, maxIndex));
    } else {
      api.start({
        x: offsetX,
        immediate: true
      });
    }
  }, {
    transform: function transform(_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        xt = _ref2[0],
        y = _ref2[1];
      return [-xt, y];
    },
    from: function from() {
      return [x.get(), 0];
    },
    bounds: function bounds() {
      return {
        left: 0,
        right: (count - 1) * slideWidth
      };
    },
    rubberband: true,
    axis: "x",
    pointer: {
      touch: true
    }
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: "".concat(classPrefix, "-slides")
  }, bind()), /*#__PURE__*/React.createElement(animated.div, {
    className: "".concat(classPrefix, "-indicator")
  }, x.to(function (v) {
    var index = bound(Math.round(v / slideWidth), 0, count - 1);
    return "".concat(index + 1, " / ").concat(count);
  })), /*#__PURE__*/React.createElement(animated.div, {
    className: "".concat(classPrefix, "-slides-inner"),
    style: {
      x: x.to(function (xt) {
        return -xt;
      })
    }
  }, props.images.map(function (image, index) {
    return /*#__PURE__*/React.createElement(Slide, {
      key: index,
      image: image,
      onTap: props.onTap,
      maxZoom: props.maxZoom,
      onZoomChange: function onZoomChange(zoom) {
        if (zoom !== 1) {
          var idx = Math.round(x.get() / slideWidth);
          api.start({
            x: idx * slideWidth
          });
        }
      },
      dragLockRef: dragLockRef
    });
  })));
});